import { api } from "./api";

export const filtersApiSlice = api.injectEndpoints({
  // ********* Not using deprecated API ********* 
  endpoints: (builder) => ({
    getFiltersList: builder.query({
      query: ({
        categorySlug = "",
        rebateId = "",
        brandIds = "",
        isAvailabilty = "",
        zipCode = "",
        deliveryDate = "",
        onDisplay = "",
        storeId = "",
        onSale = "",
        clearance = "",
        rebateAvailable = "",
        fieldIds = "",
        fieldValueIds = "",
        height = "",
        width = "",
        depth = "",
        totalCapacity="",
        iceCapacity="",
        dailyIceProduction="",
        ovenCapacity= "",
        washerHeight="",
        washerWidth="",
        washerDepth="",
        dryerHeight="",
        dryerWidth="",
        dryerDepth="", 
        capacity="",  
        type=""
      }) => {
        // Construct the URL conditionally based on the categorySlug
        const url =
          categorySlug !== "products"
            ? `/getFilters?slug=${categorySlug}&rebateId=${rebateId}&brandIds=${brandIds}&isAvailabilty=${isAvailabilty}&zipCode=${zipCode}&deliveryDate=${deliveryDate}&onDisplay=${onDisplay}&storeId=${storeId}&onSale=${onSale}&clearance=${clearance}&rebateAvailable=${rebateAvailable}&fieldIds=${fieldIds}&fieldValueIds=${fieldValueIds}&height=${height}&width=${width}&depth=${depth}&totalCapacity=${totalCapacity}&iceCapacity=${iceCapacity}&dailyIceProduction=${dailyIceProduction}&type=${type}&ovenCapacity=${ovenCapacity}&washerHeight=${washerHeight}&washerWidth=${washerWidth}&washerDepth=${washerDepth}&dryerHeight=${dryerHeight}&dryerWidth=${dryerWidth}&dryerDepth=${dryerDepth}&capacity=${capacity}`
            : "/getFilters";

        return url;
      },
      providesTags: ["filters"],
    }),
  }),
});

export const { useGetFiltersListQuery } = filtersApiSlice;
